import { Component, OnInit, ViewChild } from '@angular/core';
import swal from 'sweetalert2';
import { ConfigurationService } from '../../../../../services/configuration.service';
import { LanguageModel } from '../../../../../models/language.model';
import { LanguageModalComponent } from '../../language-modal/language-modal.component';
import { ModalTransferModel } from '../../../../../models/modal-transfer.model';
import { AuthService, CommonService, InternationalizationService } from '../../../../../services';
import { ClrDatagrid, ClrDatagridStateInterface } from '@clr/angular';

@Component({
    selector: 'app-language-table',
    templateUrl: './language-table.component.html',
    styleUrls: ['./language-table.component.scss']
})

export class LanguageTableComponent implements OnInit {
    data: Array<LanguageModel> = [];
    dataFiltered: Array<LanguageModel> = [];
    selectedLanguage: LanguageModel;

    tableState = 0;

    openLanguageModal: boolean;
    modalReference: ModalTransferModel;

    filterItems: any = {
        id: { key: 'id', name: 'ID' },
        name: { key: 'name', name: 'Name' },
        code: { key: 'code', name: 'Code' },
        flag: { key: 'flag', name: 'Flag' }
    }
    filters = [];

    @ViewChild('dataGrid') dataGrid: ClrDatagrid;
     

    constructor(private confSvc: ConfigurationService, private auth: AuthService,
        private i18Svc: InternationalizationService,
        public common: CommonService) {
            this.i18Svc.initialize();
    }
    canView = this.auth.canViewLanguage;
    canEdit = this.auth.canEditLanguage;
    ngOnInit() {
        this.get();
    }

    onGridStateChange(state: ClrDatagridStateInterface) {
        this.filters = state?.filters || [];
    }
      
    filter(filterValue: string) {
        filterValue = filterValue?.toUpperCase();
        this.dataFiltered = this.data.filter(x => x.id?.toString()?.toUpperCase().indexOf(filterValue) > -1
            || x.name?.toUpperCase().indexOf(filterValue) > -1
            || x.code?.toUpperCase().indexOf(filterValue) > -1
            || x.flag?.toUpperCase().indexOf(filterValue) > -1);
    }
    refresh() {
        this.get();
    }

    edit(): void {
        let modalTitle = '';
        if (this.canEdit) {
            modalTitle = 'edit';
        }

        else {
            modalTitle = 'open';
        }
        this.openLanguageModal = true;
        const selected = JSON.parse(JSON.stringify(this.selectedLanguage));
        this.modalReference = new ModalTransferModel(modalTitle, LanguageModalComponent, selected, null, null);
    }

    add(): void {
        if (this.canEdit) {
            this.openLanguageModal = true;
            this.modalReference = ModalTransferModel.createMode(LanguageModalComponent);
        }
    }

    onLanguageModalClose(refresh): void {
        this.openLanguageModal = false;
        if(refresh) {
            this.refresh();
        }
    }

    get() {
        if (this.canView) {
            this.tableState = 1;
            this.data = [];
            this.dataFiltered = [];
            this.confSvc.getLanguage()
                .subscribe(data => this.onGet(data), err => this.onGetError(err));
        }
    }

    onGet(data) {
        if (data['result']) {
            this.data = [];
            this.dataFiltered = [];
            data['result'].forEach(x => {
                this.data.push(LanguageModel.parse(x));
                this.dataFiltered.push(LanguageModel.parse(x));
            });
            this.tableState = 2;
        } else {
            this.tableState = 4;
        }
    }
    onGetError(err) {
        this.onError(err);
    }
    onError(msg) {
        swal({
            position: 'top-end',
            type: 'error',
            title: 'Oops...',
            text: msg,
            footer: '<a href>Why do I have this issue?</a>'
        });
    }
}
